import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { Ethos } from "@/components/site/Ethos";
import { Products } from "@/components/site/Products";
import { Legacy } from "@/components/site/Legacy";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="bg-void text-plasma min-h-screen">
        <Nav />
        <main>
          <Hero />
          <MarqueeStrip />
          <Ethos />
          <Products />
          <Legacy />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </ReactLenis>
  );
}

export default App;
